// extracted by mini-css-extract-plugin
export default {"permissionRow":"ViewPermissionsModal_permissionRow__TqjWU","permissionAttributeCol":"ViewPermissionsModal_permissionAttributeCol__HrR+v"};